import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m18.125 23.75 2.5 2.5 5.625-5.625m1.231-4.938c.013-.227.019-.456.019-.687 0-6.904-5.596-12.5-12.5-12.5S2.5 8.096 2.5 15c0 6.794 5.42 12.323 12.173 12.496M15 7.5V15l4.673 2.337",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }